import {createSelector} from '@ngrx/store';
import * as fromFeature from '@app/shared/store/reducers';
import * as fromClients from '@app/shared/store/reducers/users.reducers';

export const selectClientsState = createSelector(
  fromFeature.selectSharedFeatureState,
  (state: fromFeature.State) => state.users
);

export const getClients = createSelector(
  selectClientsState,
  fromClients.getClients
);

export const getManagers = createSelector(
  selectClientsState,
  fromClients.getManagers
);

export const getSortedManagers = createSelector(
  selectClientsState,
  fromClients.getSortedManagers
);
